import { openSessionTimeoutModal } from './sessionTimeOutActions';
import {STOP_LOADING,START_LOADING, EXPORT_REPORT_FAILURE, EXPORT_REPORT_SUCCESS, EXPORT_REPORT_REQUEST} from "./actionTypes";

//// Last Login by adarsh /////

import { getExpiredPolicyDataServices,
  getFilterReportCarrierName, getFilterReportLocationGroup, getFilterReportMissingDocument,
   getFilterReportQuoteType, getFilterReportSource, getFilterReportZipCode,
   getLastLoginDataServices, getLeadSourceReportDataServices, getLineOfBusinessDataServices,
    getmissingDocumnetsDataServices, getPendingCancellationDataServices,
    getpolicyReportDataServices, getquoteStatusDataServices,
    getRenewalReportDataServices, getReportCarrierName,
    getReportLocationGroup, getReportMissingDocument, getReportQuoteType,
    getReportSource, getReportZipCode, getEmployeeSummaryService,
  getAllProductionReportService,
getSearchAllProductionReportService, getZipCodeService,
exportReport,
exportLeadReport,
exportEmployeeLogReportService,
exportTaskReportService,
exportRaterReportService} from "../../services/reportService";

export const getLastLoginDataAction = (filters, page = 0, size = 5, sort = []) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'START_LOADING' });

    const token = getState().auth.token || sessionStorage.getItem("token");

    const response = await getLastLoginDataServices(token, filters, page, size, sort);

    dispatch({ type: 'LAST_LOGIN_DATA_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: 'LAST_LOGIN_DATA_FAILURE', payload: error.message });
  } finally {
    dispatch({ type: 'STOP_LOADING' });
  }
};

////// line of business  BY adarsh /////

  export const getLineOfBusinessDataAction = (formData, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getLineOfBusinessDataServices(formData, page, size,token);  //POLICY ID TO BE PASS
        dispatch({ type: 'LINE_OF_BUSINESS_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'LINE_OF_BUSINESS_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };

  ////  EXPIRED POLICY by adarsh /////

  export const getExpiredPolicyDataAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getExpiredPolicyDataServices(token, id, page, size);  //POLICY ID TO BE PASS
        dispatch({ type: 'EXPIRED_POLICY_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'EXPIRED_POLICY_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };


/////// Renewal  Report  BY Gagan //////
  export const getRenewalReportDataAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await  getRenewalReportDataServices(token, id, page, size);
        dispatch({ type: 'RENEWAL_REPORT_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'RENEWAL_REPORT_DATA_FAILURE', payload: error.message });
         } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };
  //Rakesh Action of Report

   export const getReportMissingDocumentAction= (id,page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getReportMissingDocument(id,page,size,token);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: "GET_REPORT_MISSING_DOCUMENT_SUCCESS", payload: response });
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'Report Missing Document' });
          dispatch({ type: "GET_REPORT_MISSING_DOCUMENT_FAILURE", payload: error || 'All report  missing document service failed. Please try again.' });
        }
      }
    };

     export const getFilterReportMissingDocumentAction = (formData, page = 0, rowsPerPage = 5) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token ||sessionStorage.getItem("token");
          if (!token) {
            dispatch(openSessionTimeoutModal());
            return;
          }
          const response = await getFilterReportMissingDocument(formData, token, page, rowsPerPage);
          dispatch({ type: 'FILTER_REPORT_MISSING_DOCUMENT_SUCCESS', payload: response });
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: 'FILTER_REPORT_MISSING_DOCUMENT_FAILURE', payload: error.message || 'Failed to fetch all missing document. Please try again.' });
          }
        }
      };

     export const getReportSourceAction= (id,page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getReportSource(id,page,size,token);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: "GET_REPORT_SOURCE_SUCCESS", payload: response });
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'Report Source' });
          dispatch({ type: "GET_REPORT_SOURCE_FAILURE", payload: error || 'All report Source service failed. Please try again.' });
        }
      }
    };

     export const getFilterReportSourceAction = (formData, page = 0, rowsPerPage = 5) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token ||sessionStorage.getItem("token");
          if (!token) {
            dispatch(openSessionTimeoutModal());
            return;
          }
          const response = await getFilterReportSource(formData, token, page, rowsPerPage);
          dispatch({ type: 'FILTER_REPORT_SOURCE_SUCCESS', payload: response });
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: 'FILTER_REPORT_SOURCE_FAILURE', payload: error.message || 'Failed to fetch all report source. Please try again.' });
          }
        }
      };

     export const getReportCarrierNameAction= (id,page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getReportCarrierName(id,page,size,token);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: "GET_REPORT_CARRIER_NAME_SUCCESS", payload: response });
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'Report Carrier Name' });
          dispatch({ type: "GET_REPORT_CARRIER_NAME_FAILURE", payload: error || 'All report carrier name service failed. Please try again.' });
        }
      }
    };

 export const getFilterReportCarrierNameAction = (formData, page = 0, rowsPerPage = 5) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token ||sessionStorage.getItem("token");
          if (!token) {
            dispatch(openSessionTimeoutModal());
            return;
          }
          const response = await getFilterReportCarrierName(formData, token, page, rowsPerPage);
          dispatch({ type: 'FILTER_REPORT_CARRIER_NAME_SUCCESS', payload: response });
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: 'FILTER_REPORT_CARRIER_NAME_FAILURE', payload: error.message || 'Failed to fetch all report carrier. Please try again.' });
          }
        }
      };

     export const getReportQuoteTypeAction= (id,page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getReportQuoteType(id,page,size,token);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: "GET_REPORT_QUOTE_TYPE_SUCCESS", payload: response });
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'Report Quote Type' });
          dispatch({ type: "GET_REPORT_QUOTE_TYPE_FAILURE", payload: error || 'All report quote type service failed. Please try again.' });
        }
      }
    };

     export const getFilterReportQuoteTypeAction = (formData, page = 0, rowsPerPage = 5) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token ||sessionStorage.getItem("token");
          if (!token) {
            dispatch(openSessionTimeoutModal());
            return;
          }
          const response = await getFilterReportQuoteType(formData, token, page, rowsPerPage);
          dispatch({ type: 'FILTER_REPORT_QUOTE_TYPE_SUCCESS', payload: response });
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: 'FILTER_REPORT_QUOTE_TYPE_FAILURE', payload: error.message || 'Failed to fetch Filter Report Quote Type. Please try again.' });
          }
        }
      };

// ✅ Action Creator (POST with body)
export const getRaterReportAction = (filters, page = 0, size = 5,sortField = "",
    sortOrder = "asc") => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'START_LOADING' });

    const token = getState().auth.token || sessionStorage.getItem("token");

    const response = await getReportZipCode(filters, page, size, token, sortField,
        sortOrder);

    dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });

    dispatch({ type: "SEARCH_RATER_REPORT_SUCCESS", payload: response });
  } catch (error) {

      dispatch({ type: STOP_LOADING, service: 'Report Zip Code' });
      dispatch({
        type: "GET_REPORT_ZIP_CODE_FAILURE",
        payload: error || 'All rater report   service failed. Please try again.',
      });

  }
};





     export const getFilterReportZipCodeAction = (formData, page = 0, rowsPerPage = 5) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token ||sessionStorage.getItem("token");
          if (!token) {
            dispatch(openSessionTimeoutModal());
            return;
          }
          const response = await getFilterReportZipCode(formData, token, page, rowsPerPage);
          dispatch({ type: 'FILTER_REPORT_ZIP_CODE_SUCCESS', payload: response });
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: 'FILTER_REPORT_ZIP_CODE_FAILURE', payload: error.message || 'Failed to fetch filter report zip code. Please try again.' });
          }
        }
      };

       export const getReportLocationGroupAction= (id,page = 0, size = 5) => async (dispatch, getState) => {
      try {
        dispatch({ type: START_LOADING, service: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getReportLocationGroup(id,page,size,token);
        dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        dispatch({ type: "GET_REPORT_LOCATION_GROUP_SUCCESS", payload: response });
      } catch (error) {
        if(error?.includes("403")) {
          dispatch(openSessionTimeoutModal());
        } else {
          dispatch({ type: STOP_LOADING, service: 'Report Location Group' });
          dispatch({ type: "GET_REPORT_LOCATION_GROUP_FAILURE", payload: error || 'All report location group service failed. Please try again.' });
        }
      }
    };

       export const getFilterReportLocationGroupAction = (formData, page = 0, rowsPerPage = 5) => async (dispatch, getState) => {
        try {
          dispatch({ type: START_LOADING, service: 'START_LOADING' });
          const token = getState().auth.token ||sessionStorage.getItem("token");
          if (!token) {
            dispatch(openSessionTimeoutModal());
            return;
          }
          const response = await getFilterReportLocationGroup(formData, token, page, rowsPerPage);
          dispatch({ type: 'FILTER_REPORT_LOCATION_GROUP_SUCCESS', payload: response });
          dispatch({ type: STOP_LOADING, service: 'STOP_LOADING' });
        } catch (error) {
          if(error?.includes("403")) {
            dispatch(openSessionTimeoutModal());
          } else {
            dispatch({ type: 'FILTER_REPORT_LOCATION_GROUP_FAILURE', payload: error.message || 'Failed to fetch filter report location group. Please try again.' });
          }
        }
      };

  //Rakesh Action of Report
  export const getquoteStatusDataAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getquoteStatusDataServices(token, id, page, size);
        dispatch({ type: 'QUOTE_STATUS_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'QUOTE_STATUS_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };


///// LeadSourceReport BY Gagan //////
   export const getLeadSourceReportDataAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await  getLeadSourceReportDataServices(token, id, page, size);
        dispatch({ type: 'LEAD_SOURCE_REPORT_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'LEAD_SOURCE_REPORT_DATA_FAILURE', payload: error.message });
         } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };
  export const getpolicyReportDataAction = (formData, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getpolicyReportDataServices(formData, page, size,token);
        dispatch({ type: 'POLICY_REPORT_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'POLICY_REPORT_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };


 /////  Pending Cancellation bt Gagan /////
   export const getPendingCancellationDataAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await  getPendingCancellationDataServices(token, id, page, size);
        dispatch({ type: 'PENDING_CANCELLATION_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'PENDING_CANCELLATION_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };

  export const getEmployeeSummaryAction = (formData, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getEmployeeSummaryService(formData, token, page, size);
        dispatch({ type: 'TASK_STATUS_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'TASK_STATUS_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
};

  export const getmissingDocumnetsDataAction = (id, page = 0, size = 5) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getmissingDocumnetsDataServices(token, id, page, size);
        dispatch({ type: 'MISSING_DOCUMNETS_DATA_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'MISSING_DOCUMNETS_DATA_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };
export const getSearchAllProductionReportAction = (
  formData,
  page = 0,
  size = 5,
  sortField = "",
  sortOrder = "asc"
) => async (dispatch, getState) => {
  try {
    dispatch({ type: 'START_LOADING' });
    const token = getState().auth.token || sessionStorage.getItem("token");

    const response = await getSearchAllProductionReportService(
      formData,
      token,
      page,
      size,
      sortField,
      sortOrder
    );

    dispatch({ type: 'GET_SEARCH_PRODUCTION_REPORT_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: 'GET_SEARCH_PRODUCTION_REPORT_FAILURE', payload: error.message });
  } finally {
    dispatch({ type: 'STOP_LOADING' });
  }
};


 export const getAllProductionReportAction = (page = 0, size = 5, property, sortType) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getAllProductionReportService(token, page, size, property, sortType);
        dispatch({ type: 'GET_ALL_PRODUCTION_REPORT_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'GET_ALL_PRODUCTION_REPORT_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };

  export const getZipCodeAction = (zipcode) => async (dispatch, getState) => {
    try {
        dispatch({ type: 'START_LOADING' });
        const token = getState().auth.token || sessionStorage.getItem("token");
        const response = await getZipCodeService(zipcode, token);
        dispatch({ type: 'GET_ZIP_CODE_SUCCESS', payload: response });
    } catch (error) {
        dispatch({ type: 'GET_ZIP_CODE_FAILURE', payload: error.message });
    } finally {
        dispatch({ type: 'STOP_LOADING' });
    }
  };

export const exportReportAction = (filters, format, sortField, sortOrder) => async (dispatch, getState) => {
  dispatch({ type: EXPORT_REPORT_REQUEST });
  const token = getState().auth.token || sessionStorage.getItem("token");

  try {
    await exportReport(filters, format, token, sortField, sortOrder);
    dispatch({ type: EXPORT_REPORT_SUCCESS });
  } catch (error) {
    dispatch({ type: EXPORT_REPORT_FAILURE, payload: error.message });
  }
};


export const exportLeadReportAction = (filters, format) => async (dispatch, getState) => {
  dispatch({ type: 'EXPORT_LEAD_REPORT_REQUEST' });

  const token = getState()?.auth?.token || sessionStorage.getItem("token");
  try {
    await exportLeadReport(filters, format, token);
    dispatch({ type: 'EXPORT_LEAD_REPORT_SUCCESS' });
  } catch (err) {
    dispatch({ type: 'EXPORT_LEAD_REPORT_FAILURE', payload: err?.toString?.() || "Export failed" });
    throw err;
  }
};

export const exportEmployeeLogReportAction = (filters, format) => async (dispatch, getState) => {
  dispatch({ type: EXPORT_REPORT_REQUEST });
  const token = getState().auth.token || sessionStorage.getItem("token");

  try {
    await exportEmployeeLogReportService(filters, format, token);
    dispatch({ type: EXPORT_REPORT_SUCCESS });
  } catch (error) {
    dispatch({ type: EXPORT_REPORT_FAILURE, payload: error.message });
  }
};
export const exportTaskReportAction = (filters, format) => async (dispatch, getState) => {
  dispatch({ type: EXPORT_REPORT_REQUEST });
  const token = getState().auth.token || sessionStorage.getItem("token");

  try {
    await exportTaskReportService(filters, format, token);
    dispatch({ type: EXPORT_REPORT_SUCCESS });
  } catch (error) {
    dispatch({ type: EXPORT_REPORT_FAILURE, payload: error.message });
  }
};
export const exportRaterReportAction = (filters, format) => async (dispatch, getState) => {
  dispatch({ type: EXPORT_REPORT_REQUEST });
  const token = getState().auth.token || sessionStorage.getItem("token");

  try {
    await exportRaterReportService(filters, format, token);
    dispatch({ type: EXPORT_REPORT_SUCCESS });
  } catch (error) {
    dispatch({ type: EXPORT_REPORT_FAILURE, payload: error.message });
  }
};